import { Component, computed, input, output } from '@angular/core';

import { CropFieldNutrientCalculations } from '../../../shared/models/models';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';

@Component({
  selector: 'app-crop-field-selector',
  template: `
    <mat-form-field>
      <mat-select
        [value]="selectedCropFieldId()"
        (selectionChange)="onCropFieldChange($event.value)"
        [disabled]="isDisabled()"
      >
        @for (cropField of sortedCropFields(); track cropField.id) {
          <mat-option [value]="cropField.id">{{ cropField.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        min-width: 0;
      }

      mat-form-field {
        display: block;
        width: 100%;
        min-width: 0;
      }
    `,
  ],
  imports: [
    MatFormField,
    MatSelect,
    MatOption,
  ],
})
export class CropfieldSelectorComponent {
  cropFields = input<CropFieldNutrientCalculations[]>([]);
  selectedCropFieldId = input<number | null>(null);

  selectedCropFieldIdChange = output<number>();

  sortedCropFields = computed<CropFieldNutrientCalculations[]>(() =>
    [...this.cropFields()].sort((a, b) => a.name.localeCompare(b.name)),
  );

  hasMultipleCropFields = computed<boolean>(() => this.cropFields().length > 1);
  isDisabled = computed<boolean>(() => !this.hasMultipleCropFields());

  protected onCropFieldChange(newId: number) {
    this.selectedCropFieldIdChange.emit(newId);
  }
}
